import { ColorFieldDefinition, ColorFieldsConfig } from "../types";

interface FieldConfig {
  key: string;
  label: string;
  condition?: boolean;
  useOpacity?: {
    defaultColor: string;
    opacity: number;
  };
  defaultColor?: string;
  useContrastText?: boolean;
  useContrastTextOpacity?: number;
}

export const createColorField = (
  config: FieldConfig,
  colorFieldsConfig: ColorFieldsConfig
): ColorFieldDefinition & { color: string } => {
  const { key, label, condition = true, useOpacity, defaultColor } = config;
  const { getColorForDisplayLocal, getColorForDisplayWithOpacity, colorTheme } =
    colorFieldsConfig;

  const getValue = (fieldPath: string) => {
    return fieldPath.split(".").reduce((obj, path) => obj?.[path], colorTheme);
  };

  const color = useOpacity
    ? (() => {
        const storedValue = getValue(key);
        // If we have a stored hex8 value (8 characters), use it directly
        if (
          storedValue &&
          typeof storedValue === "string" &&
          storedValue.match(/^#[0-9a-fA-F]{8}$/)
        ) {
          return storedValue;
        }
        // Otherwise, use the opacity conversion function
        return getColorForDisplayWithOpacity(
          key,
          storedValue,
          useOpacity.defaultColor,
          useOpacity.opacity
        );
      })()
    : getColorForDisplayLocal(key, getValue(key), defaultColor);

  return {
    key,
    label,
    color,
    condition,
  };
};

export const createFieldGroup = (
  fields: FieldConfig[],
  colorFieldsConfig: ColorFieldsConfig
): (ColorFieldDefinition & { color: string })[] => {
  return fields.map((field) => createColorField(field, colorFieldsConfig));
};
